import React from "react";
import {
  LockOutlined,
  UserOutlined,
  BarChartOutlined,
  TeamOutlined,
  SettingOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { Button, Form, Input, Typography, Space } from "antd";
import { useLogin } from "lib/auth";
import "./login.css";

const { Title, Text } = Typography;

const featureItems = [
  {
    icon: <BarChartOutlined />,
    label: "Monitor platform analytics",
  },
  {
    icon: <TeamOutlined />,
    label: "Manage users and access",
  },
  {
    icon: <SettingOutlined />,
    label: "Configure system settings",
  },
  {
    icon: <SafetyCertificateOutlined />,
    label: "Secure admin authentication",
  },
];

const LogInPage = () => {
  const login = useLogin();

  const onFinish = (values) => {
    login.mutate(values);
  };

  return (
    <div className="login-page">
      <div className="login-layout">
        <div className="login-left">
          <div className="brand">
            <Title level={2}>ScanU Admin</Title>
          </div>

          <Text className="description">
            Access the ScanU administrative dashboard to manage platform
            operations, monitor analytics, and control system settings securely.
          </Text>

          <div className="features">
            {featureItems.map((item) => (
              <div className="feature-row" key={item.label}>
                <span className="feature-icon">{item.icon}</span>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="login-right">
          <div className="login-card">
            <div className="login-header">
              <Title level={3}>Admin Login</Title>
              <Text type="secondary">
                Sign in to access the ScanU dashboard
              </Text>
            </div>

            <Form
              layout="vertical"
              name="admin_login"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Enter your email" },
                  { type: "email", message: "Enter a valid email" },
                ]}
              >
                <Input
                  size="large"
                  prefix={<UserOutlined />}
                  placeholder="admin@scanu.com"
                />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: "Enter your password" }]}
              >
                <Input.Password
                  size="large"
                  prefix={<LockOutlined />}
                  placeholder="Enter password"
                />
              </Form.Item>

              <Button
                loading={login.isPending}
                type="primary"
                htmlType="submit"
                size="large"
                block
                className="login-button"
              >
                Log In
              </Button>

              <div className="security-note">
                <Space size={6}>
                  <LockOutlined />
                  <span>
                    Secure admin access. Unauthorized usage is prohibited.
                  </span>
                </Space>
              </div>

              <div className="login-footer">
                Copyright {new Date().getFullYear()} ScanU
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogInPage;
